<template>
    <v-card class="theme-background theme-border theme-text d-inline-flex align-center pl-1 pr-1" :class="substitute ? 'player-entry-substitute' : 'player-entry'" depressed tile flat/>
</template>

<script>
    export default {
        name: "PlayerSpace",
        props: {
            substitute: Boolean,
        },
    }
</script>

<style scoped>
    .player-entry {
        font-size: 12px;
        border-style: solid;
        border-left-width: 1px !important;
        border-right-width: 1px !important;
        border-top-width: 0 !important;
        border-bottom-width: 0 !important;
    }

    .player-entry-substitute {
        font-size: 12px;
        border-style: solid;
        border-left-width: 0;
        border-right-width: 0;
        border-top-width: 0 !important;
        border-bottom-width: 0 !important;
        width: 100%;
        height: 100%;
    }
</style>